import { useEffect, useRef, useState } from "react";
import { LinearProgress, Tooltip, IconButton, FormHelperText } from "@mui/material";
import { uploadChatFiles } from "../../../../bmr/slices/chat"
import { SUPPORTED_FORMATS, MAX_FILE_SIZE } from "../../../../pages/appointment-details/common-pre-screen/common";
import { useDispatch } from "react-redux";
import { DeleteIconButton,EyeIconButton } from "../../../../assets/common-svg/CommonSvg";
import FilePreviewModal from "../../../../bmr/components/common/FilePreview"
import { deleteFile } from "../../../../bmr/slices/appointment";
import DeleteModal from "../../../../bmr/components/common/BaseModal/DeleteModal";
import { notify } from "../../../utils/methods/notification";
import DownloadFiles from "../../../../bmr/components/common/DownloadFiles/index"

const FileUploadComponent = ({ field, formData, setFormData, setErrors }) => {
  const fileInputRef = useRef(null);
  const [fileValues, setFileValues] = useState([])
  const [isUploading, setIsUploading] = useState(false);
  const [previewOpen, setPreviewOpen] = useState(false);
  const [filePreview, setFilePreview] = useState("");
  const [deleteModal, setDeleteModal] = useState(null);   
  const dispatch = useDispatch();


    const handleDownload = async (id) => {
          const url = await field?.downloadFile(id);
          setFilePreview(url);
          setPreviewOpen(true);
        };

  const handleUploadFiles = async (e) => {
    const {  files } = e.target;
    const AllFiles = Array.from(files);
    
    if (AllFiles?.length !== 0) {
      const validFiles = AllFiles.filter(
        (file) =>
          SUPPORTED_FORMATS.includes(file.type || file.file_type) &&
          (file.size <= MAX_FILE_SIZE || file.file_size <= MAX_FILE_SIZE)
      );

      if (files.length > 0 && validFiles.length === 0) {
        notify.error("Files must be supported format and under 25MB")
        if(setErrors){
        setErrors(prev => ({
          ...prev,
          media_id: "Files must be supported format and under 25MB"
        }));
      }
        return;
      }

      setIsUploading(true);
      try {
        const formDataFile = new FormData();
        validFiles.forEach((file) => {
          formDataFile.append('files', file);
        });
        const res = await dispatch(uploadChatFiles(formDataFile));
        if (uploadChatFiles?.fulfilled?.match(res)) {
          // If multiple files, append to existing files, otherwise replace
          const currentFiles = formData.media_id || [];
          const mediaIds = Array.isArray(res?.payload) ?  res?.payload?.map(item => item.media_id) : [res?.payload?.media_id];
          const updatedFiles =  [...(Array.isArray(currentFiles) ? currentFiles : []), ...mediaIds]
          setFileValues(prev => [...prev,   ...(Array.isArray(res.payload) ? res.payload : [res.payload])]);
          setFormData(prev => ({ ...prev, media_id: updatedFiles }));
        }
      } catch (error) {
        console.error("Upload error:", error);
      } finally {
        setIsUploading(false);
        // Clear the input
        if (fileInputRef.current) {
          fileInputRef.current.value = "";
        }
      }
    }
  };


  const handleRemoveFile = async() => {
      const res = await dispatch(deleteFile(deleteModal?.id));
     if (res?.payload?.status === 200) {
    if (field?.multiple) {
      const updatedFiles = formData?.media_id?.filter(file => file !== deleteModal?.id);
      setFileValues(prev => (prev || []).filter(item => String(item?.media_id) !== String(deleteModal?.id)));
      setFormData(prev => ({ ...prev, media_id: updatedFiles }));
    } else {
      setFormData(prev => ({ ...prev, media_id: null }));
      setFileValues(null)
    }
  }
  setDeleteModal(null);
  };

  useEffect(() =>{
    setFileValues(formData?.media || [])
  },[formData?.media])
  return (
    <div className="mt-1">
      {fileValues?.length !== 0 && field?.disabled ? (
        (fileValues?.length || fileValues?.file_name) ? '' :
        <h5 className="font-medium mt-1"> No File Uploaded</h5>
      ) : (
        <>
          <input
            type="file"
            name={field?.name}
            multiple={field?.multiple}
            ref={fileInputRef}
            onChange={handleUploadFiles}
            style={{
              ...(field?.disabled && {
                backgroundColor: "#F0F1F5",
                color: "#5c5959",
              }),
              border: "1px solid",
              padding: "18px",
            }}
            disabled={field?.disabled || isUploading}
            accept={field?.acceptFormat?.join(",")}
            className={`border w-100 rounded-md p-2 border-gray-300
                file:mr-4 file:py-2 file:px-4 file:rounded-md file:border-0 file:text-sm file:font-semibold
                ${
                  field?.disabled
                    ? "file:bg-[#F0F1F5] file:text-[#5c5959]"
                    : "file:bg-blue-50 file:text-blue-700 hover:file:bg-blue-100"
                }`}
          />

          {/* Loader */}
          {isUploading && (
            <div className="mt-2 flex items-center gap-2 text-blue-600">
              <div className="w-100">
                <LinearProgress color="info" />
              </div>
              <span>Uploading...</span>
            </div>
          )}
        </>
      )}
      {/* Display uploaded files */}
      {fileValues && (
        <div className="mt-1">
          {Array.isArray(fileValues) ? (
            fileValues?.map((file, index) => (
              <div
                key={file?.id || file?.media_id || index}
                className="flex items-center justify-between bg-gray-100 p-2 rounded mb-1"
              >
                <span className="truncate max-w-xs">
                  {file?.file || file?.file_name} {file.file_size ? '('+ Math.round((file.file_size) / 1024) +'KB)':''}
                </span>
                <div className="flex gap-2">
                  {!field?.removeButton && (
                    <Tooltip title="Delete">
                      <span>
                        <IconButton
                          disabled={field?.disabled}
                          onClick={() =>  setDeleteModal({name:file?.file || file?.file_name,id:file?.media_id | file?.id})}
                        >
                          <DeleteIconButton
                            bgColor={"#FA5151"}
                            disabled={field?.disabled}
                          />
                        </IconButton>
                      </span>
                    </Tooltip>
                  )}
                  {(file?.media_id || file?.id) ? ( <>
                      <Tooltip title="View">
                        <span>
                          <IconButton
                            onClick={() => handleDownload(file?.media_id || file?.id)}
                          >
                            <EyeIconButton bgColor={"#3571FF"} />
                          </IconButton>
                        </span>
                      </Tooltip>
                       <DownloadFiles
                                              fileId={file?.media_id || file?.id}
                                              fileName={file?.file || file?.file_name}
                                          /></>
                    ):''}
                </div>
              </div>
            ))
          ) : fileValues && typeof fileValues === 'object' && fileValues?.media_id ? (
            <div className="flex mt-2 items-center justify-between bg-gray-100 p-2 rounded">
              <span className="truncate max-w-xs">
                {fileValues.file} (
                {Math.round((fileValues.file_size) / 1024)} KB)
              </span>
              <div className="flex gap-2">
                {!field?.removeButton && (
                  <Tooltip title="Delete">
                    <span>
                      <IconButton
                        disabled={field?.disabled}
                        onClick={() =>  setDeleteModal({name:fileValues.file,id:fileValues.media_id})}
                      >
                        <DeleteIconButton
                          bgColor={"#FA5151"}
                          disabled={field?.disabled}
                        />
                      </IconButton>
                    </span>
                  </Tooltip>
                )}
                {fileValues?.media_id && ( <>
                      <Tooltip title="View">
                        <span>
                          <IconButton
                            onClick={() => handleDownload(fileValues?.media_id)}
                          >
                            <EyeIconButton bgColor={"#3571FF"} />
                          </IconButton>
                        </span>
                      </Tooltip>
                       <DownloadFiles
                                              fileId={fileValues?.media_id}
                                              fileName={fileValues?.file || fileValues?.file_name}
                                          /></>
                    )}
               
              </div>
            </div>
          ) : null}
        </div>
      )}
       <DeleteModal
          open={deleteModal}
          setClose={setDeleteModal}
          title={"Are you sure you want to Delete File ?"}
          buttonText={"Delete"}
          handleSuccess={handleRemoveFile}
      />

      <FilePreviewModal
                    ModalTitle={"File Preview"}
                    setOpen={setPreviewOpen}
                    open={previewOpen}
                    fileURL={filePreview}
                  />
      {field?.error && <FormHelperText error>{field?.helperText}</FormHelperText>}
    </div>
  );
};
export default FileUploadComponent;